module.exports = __webpack_public_path__ + "img/postgres.3e68d789.svg";